// Gemerkter Monat und gemerkte Filter des Buero-Dashboards (reine Funktionen, kein Speicherzugriff).
// Das Buero prueft beim Monatsabschluss Zettel und will nicht bei jeder Rueckkehr im
// aktuellen Monat landen (Christian, 10.09.2026).

// Eigener Schluessel: Mitarbeiter- und Buero-Ansicht duerfen sich im selben Browser
// nicht gegenseitig den Monat verstellen.
export const ADMIN_MONAT_SCHLUESSEL = 'timenyzer.admin.dashboard.monat';
export const ADMIN_FILTER_SCHLUESSEL = 'timenyzer.admin.dashboard.filter';

export function gemerkterMonatAus(rohText, jahre) {
  try {
    const daten = JSON.parse(rohText);
    if (!daten || typeof daten !== 'object' || Array.isArray(daten)) return null;
    const { monat, jahr } = daten;
    if (!Number.isInteger(monat) || monat < 1 || monat > 12) return null;
    if (!Number.isInteger(jahr) || !(jahre || []).includes(jahr)) return null;
    return { monat, jahr };
  } catch {
    return null;
  }
}

export function gemerkteFilterAus(rohText, erlaubteStatus) {
  const standard = { status: 'alle', search: '', jugendamt: 'alle' };
  try {
    const daten = JSON.parse(rohText);
    if (!daten || typeof daten !== 'object' || Array.isArray(daten)) return standard;
    const ergebnis = { ...standard };
    if (typeof daten.status === 'string' && (erlaubteStatus || []).includes(daten.status)) {
      ergebnis.status = daten.status;
    }
    if (typeof daten.search === 'string') ergebnis.search = daten.search.slice(0, 200);
    if (typeof daten.jugendamt === 'string' && daten.jugendamt) ergebnis.jugendamt = daten.jugendamt;
    return ergebnis;
  } catch {
    return standard;
  }
}
